var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "logo-wrap", attrs: { "title": _vm.$t('playTurbo.navbar.title') } }, [_c('svg-icon', { staticClass: "m-logo", style: _vm.getStyle(), attrs: { "iconClass": _vm.getLogoIcon() } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };